import { useEffect, useRef } from "react";

const BarChart = ({
  chart1Configs,
  chart2Configs,
  height = 100,
}) => {
  const {
    color: chart1Color,
    percent: chart1CPercent,
    text: chart1Text,
    icon: chart1Icon,
    serieName: chart1SerieName,
  } = chart1Configs

  const {
    color: chart2Color,
    percent: chart2CPercent,
    text: chart2Text,
    icon: chart2Icon,
    serieName: chart2SerieName,
  } = chart2Configs

  const containerRef = useRef()
  const bar1Ref = useRef()
  const bar2Ref = useRef()
  const bar1LabelRef = useRef()
  const bar2LabelRef = useRef()

  const onScroll = (e) => {
    if (window.scrollY + 450 > containerRef.current?.offsetTop) {
      bar1Ref.current.className += ' start';
      bar2Ref.current.className += ' start';
      bar1LabelRef.current.className += ' start';
      bar2LabelRef.current.className += ' start';

      document.removeEventListener('scroll', onScroll);
    }
  }

  useEffect(() => {
    document.addEventListener('scroll', onScroll);
    () => document.removeEventListener('scroll', onScroll);
  }, [])

  return (
    <>
      <style jsx global>
        {`
        @keyframes animate {
          from { bottom: -100%; }
          to { bottom: 0%; }
        }
        .bar-1.start {
          bottom: -100%;
          animation: animate 1s ease forwards;
          animation-delay: 0.2s;
          animation-iteration-count: 1;
          animation-direction: alternate;
        }
        .bar-2.start {
          bottom: -100%;
          animation: animate 1s ease forwards;
          animation-delay: 0s;
          animation-iteration-count: 1;
          animation-direction: alternate;
        }
        @keyframes label-animate {
          from { opacity: 0 }
          to { opacity: 1 }
        }
        .bar-1-label.start {
          animation: label-animate 0.5s ease forwards;
          animation-delay: 1s;
          animation-iteration-count: 1;
          animation-direction: alternate;
        }
        .bar-2-label.start {
          animation: label-animate 0.5s ease forwards;
          animation-delay: 1s;
          animation-iteration-count: 1;
          animation-direction: alternate;
        }
      `}
      </style>

      <div className="w-[100%] relative overflow-hidden border-b-4 border-[#060606]" style={{ paddingTop: `${height}%` }} ref={containerRef}>
        <hr className="absolute left-0 top-0 w-full" />
        <hr className="absolute left-0 top-[33%] w-full" />
        <hr className="absolute left-0 top-[66%] w-full" />
        <div
          className={`absolute w-[25%] left-[30%] translate-x-[-50%] rounded-t-[12px] bar-1`}
          ref={bar1Ref}
          style={{
            height: `${chart1CPercent}%`,
            backgroundColor: chart1Color
          }}
        >
          <div className="relative w-full h-full">
            <p className="text-white text-[300%] font-[CentraNo2] left-[50%] translate-x-[-50%] absolute top-[10%]">
              {chart1Text}
            </p>
          </div>
        </div>

        <div
          className={`absolute left-[30%] translate-x-[-50%] bar-1-label opacity-0`}
          ref={bar1LabelRef}
          style={{
            bottom: `${chart1CPercent + 3}%`
          }}
        >
          {chart1Icon}
          {/* <img src='/images/treatment/medicine-icon-1.png' />
          <p>ซิลเดนาฟิล</p> */}
        </div>

        <div
          className={`absolute w-[25%] right-[30%] translate-x-[50%] rounded-t-[12px] bar-2`}
          ref={bar2Ref}
          style={{
            height: `${chart2CPercent}%`,
            backgroundColor: chart2Color
          }}
        >
          <div className="relative w-full h-full">
            <p className="text-white text-[300%] font-[CentraNo2] left-[50%] translate-x-[-50%] absolute top-[10%]">
              {chart2Text}
            </p>
          </div>
        </div>

        <div
          className={`absolute right-[30%] translate-x-[50%] bar-2-label opacity-0`}
          ref={bar2LabelRef}
          style={{
            bottom: `${chart2CPercent + 3}%`
          }}
        >
          {chart2Icon}
          {/* <img src='/images/treatment/medicine-icon-2.png' />
          <p>ยาหลอก</p> */}
        </div>
      </div>

      <div className="w-[100%] relative mt-6">
        <div className={`absolute left-[30%] translate-x-[-50%]`}>
          <p className="font-bold whitespace-nowrap	">{chart1SerieName}</p>
        </div>
        <div className={`absolute right-[30%] translate-x-[50%]`}>
          <p className="font-bold whitespace-nowrap	">{chart2SerieName}</p>
        </div>
      </div>
    </>
  )
}

export default BarChart;
